
import { Component } from '@angular/core';
import { CookiesService } from '../../services/admin services/cookies.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ]
})

export class CookiesComponent {

  cookieName: string = '';
  cookieValue: string = '';
  cookieDays: number = 1;
  retrievedValue: string | null = '';
  showBanner = true;
  isPrivacyPage = false;

  constructor(
    private _cookiesService: CookiesService
  ) {
    const cookieAccepted = this._cookiesService.getCookie('cookiesAccepted');
    this.showBanner = !cookieAccepted;
  }

  dismissBanner() {
    this.showBanner = false;
    this._cookiesService.setCookie('cookiesAccepted', 'true', {
      days: 365,
      path: '/'
    });
  }
}
